import React from 'react';

export default function TermsPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#0F1923', color: '#f1f5f9', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '60px 24px' }}>

        {/* Header */}
        <div style={{ borderBottom: '3px solid #4A7EB5', paddingBottom: 24, marginBottom: 40 }}>
          <div style={{ fontSize: 13, color: '#4A7EB5', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 2, marginBottom: 8 }}>McMullen Browne Development LLC</div>
          <h1 style={{ fontSize: 32, fontWeight: 900, margin: 0, color: '#fff' }}>Terms & Conditions</h1>
          <p style={{ color: '#94a3b8', marginTop: 8, fontSize: 14 }}>Effective Date: April 17, 2026</p>
        </div>

        <div style={{ lineHeight: 1.8, color: '#cbd5e1' }}>

          <Section title="1. SMS Messaging Program">
            McMullen Browne Development LLC operates an internal SMS notification program ("Program") to send business alerts to company employees via text message.
            <ul style={{ marginTop: 12, paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}><strong style={{ color: '#f1f5f9' }}>Program Name:</strong> McMullen Browne Internal Lead Notifications</li>
              <li style={{ marginBottom: 8 }}><strong style={{ color: '#f1f5f9' }}>Description:</strong> Automated SMS alerts sent to estimators and administrators when new customer leads are received through online advertising platforms.</li>
              <li style={{ marginBottom: 8 }}><strong style={{ color: '#f1f5f9' }}>Message Frequency:</strong> Messages are sent as new leads are received. Frequency varies based on lead volume (typically 1–20 messages per day).</li>
              <li style={{ marginBottom: 8 }}><strong style={{ color: '#f1f5f9' }}>Message & Data Rates:</strong> Standard message and data rates may apply depending on your mobile carrier plan.</li>
            </ul>
          </Section>

          <Section title="2. Opt-In">
            Participation in this SMS program is limited to McMullen Browne Development LLC employees. Consent to receive SMS notifications is obtained through an explicit, affirmative opt-in during the employee onboarding process:
            <ul style={{ marginTop: 12, paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}>New employees complete onboarding through a secure, personalized portal at mcmullenbrownecrm.com/onboard/[token], accessed via an emailed invitation link.</li>
              <li style={{ marginBottom: 8 }}>During the "Agreements &amp; Consent" step, employees are presented with a clear SMS disclosure — including program name, message frequency, message and data rate notice, opt-out instructions (STOP), and help instructions (HELP).</li>
              <li style={{ marginBottom: 8 }}>Employees must affirmatively check a consent checkbox stating: <em>"I consent to receive internal SMS notifications from McMullen Browne Development LLC at my mobile number."</em> SMS consent is never pre-checked or assumed.</li>
              <li style={{ marginBottom: 8 }}>The date, time, and IP address of consent are recorded at the moment of opt-in and retained in our system.</li>
              <li style={{ marginBottom: 8 }}>No employee's mobile number is enrolled in the SMS program without this explicit affirmative consent action.</li>
            </ul>
          </Section>

          <Section title="3. Opt-Out">
            You may opt out of receiving SMS notifications at any time by:
            <ul style={{ marginTop: 12, paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}>Replying <strong style={{ color: '#f1f5f9' }}>STOP</strong> to any message to unsubscribe immediately</li>
              <li style={{ marginBottom: 8 }}>Contacting your administrator to remove your number from the system</li>
              <li style={{ marginBottom: 8 }}>Emailing jarvis@mcmullenbrowne.com with your opt-out request</li>
            </ul>
            After opting out, you will receive one confirmation message and no further notifications.
          </Section>

          <Section title="4. Help">
            For help, reply <strong style={{ color: '#f1f5f9' }}>HELP</strong> to any message or contact us at:
            <div style={{ marginTop: 12, background: 'rgba(74,126,181,0.1)', border: '1px solid #4A7EB5', borderRadius: 8, padding: '16px 20px' }}>
              <div style={{ fontWeight: 700, color: '#f1f5f9' }}>McMullen Browne Development LLC</div>
              <div>100 South Main St, Unit 109, Newark, DE 19711</div>
              <div>Email: jarvis@mcmullenbrowne.com</div>
              <div>Phone: (302) 332-7573</div>
            </div>
          </Section>

          <Section title="5. Children's Privacy">
            This application is intended solely for use by McMullen Browne Development LLC employees and is not directed at children under the age of 13. We do not knowingly collect personal information from children under 13.
          </Section>

          <Section title="6. Use of Application">
            Access to the McMullen Browne business management application and mcmullenbrownecrm.com is restricted to authorized McMullen Browne Development LLC employees. Unauthorized access is prohibited. Users agree to:
            <ul style={{ marginTop: 12, paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}>Use the system solely for legitimate business purposes</li>
              <li style={{ marginBottom: 8 }}>Maintain the confidentiality of login credentials</li>
              <li style={{ marginBottom: 8 }}>Not share customer data with unauthorized parties</li>
              <li style={{ marginBottom: 8 }}>Report security concerns to an administrator immediately</li>
            </ul>
          </Section>

          <Section title="7. Payment Processing">
            Payment processing services are provided by Intuit Payments Inc., 2700 Coast Avenue, Mountain View, CA 94043. Phone: 1-888-536-4801. NMLS #1098819. By using our payment features, you agree to Intuit's applicable terms of service.
          </Section>

          <Section title="8. Limitation of Liability">
            McMullen Browne Development LLC is not liable for any damages arising from the use of this internal system beyond the scope of our direct business relationship.
          </Section>

          <Section title="9. Changes to Terms">
            We reserve the right to update these Terms at any time. Continued use of the system constitutes acceptance of updated Terms.
          </Section>

          <Section title="10. Contact">
            <div style={{ background: 'rgba(74,126,181,0.1)', border: '1px solid #4A7EB5', borderRadius: 8, padding: '16px 20px' }}>
              <div style={{ fontWeight: 700, color: '#f1f5f9' }}>McMullen Browne Development LLC</div>
              <div>100 South Main St, Unit 109, Newark, DE 19711</div>
              <div>Email: jarvis@mcmullenbrowne.com</div>
              <div>Phone: (302) 332-7573</div>
            </div>
          </Section>

        </div>
      </div>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 36 }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, color: '#4A7EB5', marginBottom: 12 }}>{title}</h2>
      <div style={{ fontSize: 15 }}>{children}</div>
    </div>
  );
}
